import * as React from 'react'
import { ReactElement } from 'react'
import LineItem, { LineItemProps } from './LineItem'
import { css, ISelection, Stack, StackItem } from '@fluentui/react'
import { makeStyles, Radio } from '@fluentui/react-components'
import { baseListStyles } from '../../../../List/BaseList'
import { LineItemEntity } from '../../../../../hooks/finance/invoice/useLineItemEntities'
import { TreeItem } from '@fluentui/react-components/unstable'

type Props = LineItemProps<LineItemEntity> & { selection: ISelection }

const useStyles = makeStyles({
    cell: {
        paddingTop: '0',
        paddingBottom: '0',
    },
})

export default function SelectableLineItem(props: Props): ReactElement {
    const { selection, entity } = props
    const styles = useStyles()
    return (
        <Stack
            horizontal
            verticalAlign="center"
            data-selection-index={selection.getItemIndex(entity.id)}
            className={css(baseListStyles.itemCell, styles.cell, selection.isKeySelected(entity.id) && 'is-selected')}
        >
            <Radio checked={selection.isKeySelected(entity.id)} data-selection-toggle />
            <StackItem grow>
                <TreeItem itemType="leaf">
                    <LineItem {...props} isDraggable={false} />
                </TreeItem>
            </StackItem>
        </Stack>
    )
}
